export enum StorageKeys {
  ACCESS_TOKEN = "access_token",
  REFRESH_TOKEN = "refresh_token",
  EXPIRES_AT = "expires_at",
  CONNECTION = "connection",
  SOCIAL_REDIRECT_URI = "social_redirect_uri",
}

export interface StorageInterface {
  get(key: string, defaultValue?: string): Promise<string>;
  set(key: string, value: string): Promise<void>;
  remove(key: string): Promise<void>;
  clear(): Promise<void>;
}
